
export interface CounterCustomerChargeEntity {
    id: number,
    cntrNo: string | null,
    dtlState: string | null,
    seq: string | null,
    opsDate: Date | null,
    docDate: Date | null,
    creditNoteDate: Date | null,
    chargeType: string | null,
    subChargeType: string | null,
    cntrStatus1: string | null,
    cntrSize: string | null,
    cntrType: string | null,
    chargeOnCompany: string | null,
    billToCompany: string | null,
    billToCompanyName: string | null,
    consortiumCode: string | null,
    vesselCode: string | null,
    voyageCode: string | null,
    etd: Date | null,
    tariffType: string | null,
    tariffCode: string | null,
    chargeQty: number | null,
    chargeQtyUom: string | null,
    owner1: string | null,
    truckerName: string | null,
    cnicNo: string | null,
    vehicleNo: string | null,
    nature: string | null,
    damageType: string | null,
    rate: number | null,
    remark: string | null,
    commodityCode: string | null,
    counterCustCompCode: string | null,
    defaultDraftInvoiceNo: string | null,
    defaultInvoiceNo: string | null,
    defaultCreditNo: string | null,
    draftCreditNo: string | null,
    defaultDraftCreditNo: string | null,
    adjType: string | null,
    mcNo: string | null,
    crNo: string | null,
    cntrTypeGroup: string | null,
    exceptionMsg: string | null,
    operatingTml: string | null,
    changeDateTime: Date | null,
    releaseDateTime: Date | null,
    oneoffRate: string | null,
    specialInd: string | null,
    vesselName: string | null,
    oriOwner: string | null,
    oriStatus: string | null,
    newOwner: string | null,
    newStatus: string | null,
    releaseCondition: string | null,
    chargeCode: string | null,
    telexNo: string | null,
    chargeInd: string | null,
    shipmentType: string | null,
    forwarderReference: string | null,
    bargeJobId: string | null,
    arrDateTime: Date | null,
    otherArrDateTime: Date | null,
    otherDepDateTime: Date | null,
    otherService: string | null,
    pod2: string | null,
    podInd_1: string | null,
    requestDateTime: Date | null,
    userID: string | null,
    accountTmlReasonCode: string | null,
    receiveDatetime: Date | null,
    loadingDatetime: Date | null,
    firstLoadingDataTime: Date | null,
    lastLoadingDateTime: Date | null,
    chargingFromDateTime: Date | null,
    chargingToDateTime: Date | null,
    recevalCutoffDateTime: Date | null,
    firstTierFsp: string | null,
    secondTierFsp: string | null,
    adjChargeQty: number | null,
    calendarAdjChargeqty: string | null,
    manualAdjChargeQty: string | null,
    manualAdjChargeQtyUom: string | null,
    dgContent: string | null,
    duContent: string | null,
    permitNo: string | null,
    rfTemp: string | null,
    rfTempUnit: string | null,
    dIndDischargeInd: string | null,
    soNumber: string | null,
    trainId: string | null,
    tractorNo: string | null,
    fdInd: string | null,
    waiverNo: string | null,
    pooInd: string | null,
    polInd: string | null,
    equipmentCodeInd: string | null,
    equipmentCode: string | null,
    storageDayNum: number | null,
    storageMode: string | null,
    dischargeDatetime: Date | null,
    firstDischargeDateTime: Date | null,
    lastDischargeDateTime: Date | null,
    expDateTime: Date | null,
    deliveryDateTime: Date | null,
    atb: Date | null,
    cashOtDays: number | null,
    cashAmount: number | null,
    cashReceiptNo: string | null,
    imcoCode1: string | null,
    specialCode: string | null,
    rcType: string | null,
    spHandlingInd: string | null,
    paidThroughDate: Date | null,
    poo: string | null,
    pol: string | null,
    pod1: string | null,
    fd: string | null,
    pooCountry: string | null,
    polCountry: string | null,
    podCountry: string | null,
    fdCountry: string | null,
    excessWeight: number | null,
    grossWt: string | null,
    maxGrossWeight: string | null,
    cargoCode: string | null,
    waiverReasonCode: string | null,
    waiverRejectReasonCode: string | null,
    waiverReverseReasonCode: string | null,
    waiverApprovedBy: string | null,
    waiverApprovedDatetime: Date | null,
    exciseCashNo: string | null,
    agentNo: string | null,
    agentName: string | null,
    liftInd: string | null,
    waiverNoOfDays: string | null,
    pcStartDatetime: Date | null,
    pcEndDatetime: Date | null,
    powerConsumptionDays: string | null,
    weBoc: string | null,
    serviceReferenceNo: string | null,
    serviceRequestCode: string | null,
    subServiceRequestCode: string | null,
    billOfLading: string | null,
    shippingBill: string | null,
    serviceCode: string | null,
    serviceOrderCode: string | null,
    serviceOrderNumber: string | null,
    fromDate: Date | null,
    toDate: Date | null,
    gateInDate: Date | null,
    pcPlugOnDatetime: Date | null,
    pcPlugOffDatetime: Date | null,
    additionalChargeInd: string | null,
    invoiceRemarks: string | null,
    otherSplitId: number | null,
    waiverInitBy: string | null,
    waiverSubmitedBy: string | null,
    isSuppleWaiver: boolean,
    waiverInd: string | null,
    isEditWaiver: boolean,
    adreState: string | null,
    transferFromSL: string | null,
    plugOffInd: string | null,
    isExtensionInd: string | null,
    slabsChargeInd: string | null,
    adjustmentType: string | null,
    dgSurchargeInd: string | null,
    oogSurchargeInd: string | null,
    terminalByFspInd: string | null,
    esnStatus: string | null,
    croStatus: string | null,
    holdCodeList: string | null,
    handlingDateTime: Date | null,
    lsLocationType: string | null,
    vattinCode: string | null,
    cfsBy: string | null,
    cntrOpenTime: Date | null,
    cntrCloseTime: Date | null,
    gateInDatetime: Date | null,
    gateOutDatetime: Date | null,
    numberOfLabor: number | null,
    agentDeliveryDate: Date | null,
    customsDeclarationNo: string | null,
    bookingNo1: string | null,
    iocBatchPaymentCntrSeq: string | null,

    [key: string]: string | number | Date | null | undefined | boolean
}

export const EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY: CounterCustomerChargeEntity = {
    id: 0,
    cntrNo: null,
    dtlState: null,
    seq: null,
    opsDate: null,
    docDate: null,
    creditNoteDate: null,
    chargeType: null,
    subChargeType: null,
    cntrStatus1: null,
    cntrSize: null,
    cntrType: null,
    chargeOnCompany: null,
    billToCompany: null,
    billToCompanyName: null,
    consortiumCode: null,
    vesselCode: null,
    voyageCode: null,
    etd: null,
    tariffType: null,
    tariffCode: null,
    chargeQty: null,
    chargeQtyUom: null,
    owner1: null,
    truckerName: null,
    cnicNo: null,
    vehicleNo: null,
    nature: null,
    damageType: null,
    rate: null,
    remark: null,
    commodityCode: null,
    counterCustCompCode: null,
    defaultDraftInvoiceNo: null,
    defaultInvoiceNo: null,
    defaultCreditNo: null,
    draftCreditNo: null,
    defaultDraftCreditNo: null,
    adjType: null,
    mcNo: null,
    crNo: null,
    cntrTypeGroup: null,
    exceptionMsg: null,
    operatingTml: null,
    changeDateTime: null,
    releaseDateTime: null,
    oneoffRate: null,
    specialInd: null,
    vesselName: null,
    oriOwner: null,
    oriStatus: null,
    newOwner: null,
    newStatus: null,
    releaseCondition: null,
    chargeCode: null,
    telexNo: null,
    chargeInd: null,
    shipmentType: null,
    forwarderReference: null,
    bargeJobId: null,
    arrDateTime: null,
    otherArrDateTime: null,
    otherDepDateTime: null,
    otherService: null,
    pod2: null,
    podInd_1: null,
    requestDateTime: null,
    userID: null,
    accountTmlReasonCode: null,
    receiveDatetime: null,
    loadingDatetime: null,
    firstLoadingDataTime: null,
    lastLoadingDateTime: null,
    chargingFromDateTime: null,
    chargingToDateTime: null,
    recevalCutoffDateTime: null,
    firstTierFsp: null,
    secondTierFsp: null,
    adjChargeQty: null,
    calendarAdjChargeqty: null,
    manualAdjChargeQty: null,
    manualAdjChargeQtyUom: null,
    dgContent: null,
    duContent: null,
    permitNo: null,
    rfTemp: null,
    rfTempUnit: null,
    dIndDischargeInd: null,
    soNumber: null,
    trainId: null,
    tractorNo: null,
    fdInd: null,
    waiverNo: null,
    pooInd: null,
    polInd: null,
    equipmentCodeInd: null,
    equipmentCode: null,
    storageDayNum: null,
    storageMode: null,
    dischargeDatetime: null,
    firstDischargeDateTime: null,
    lastDischargeDateTime: null,
    expDateTime: null,
    deliveryDateTime: null,
    atb: null,
    cashOtDays: null,
    cashAmount: null,
    cashReceiptNo: null,
    imcoCode1: null,
    specialCode: null,
    rcType: null,
    spHandlingInd: null,
    paidThroughDate: null,
    poo: null,
    pol: null,
    pod1: null,
    fd: null,
    pooCountry: null,
    polCountry: null,
    podCountry: null,
    fdCountry: null,
    excessWeight: null,
    grossWt: null,
    maxGrossWeight: null,
    cargoCode: null,
    waiverReasonCode: null,
    waiverRejectReasonCode: null,
    waiverReverseReasonCode: null,
    waiverApprovedBy: null,
    waiverApprovedDatetime: null,
    exciseCashNo: null,
    agentNo: null,
    agentName: null,
    liftInd: null,
    waiverNoOfDays: null,
    pcStartDatetime: null,
    pcEndDatetime: null,
    powerConsumptionDays: null,
    weBoc: null,
    serviceReferenceNo: null,
    serviceRequestCode: null,
    subServiceRequestCode: null,
    billOfLading: null,
    shippingBill: null,
    serviceCode: null,
    serviceOrderCode: null,
    serviceOrderNumber: null,
    fromDate: null,
    toDate: null,
    gateInDate: null,
    pcPlugOnDatetime: null,
    pcPlugOffDatetime: null,
    additionalChargeInd: null,
    invoiceRemarks: null,
    otherSplitId: null,
    waiverInitBy: null,
    waiverSubmitedBy: null,
    isSuppleWaiver: false,
    waiverInd: null,
    isEditWaiver: false,
    adreState: null,
    transferFromSL: null,
    plugOffInd: null,
    isExtensionInd: 'N',
    slabsChargeInd: 'N',
    adjustmentType: null,
    dgSurchargeInd: null,
    oogSurchargeInd: null,
    terminalByFspInd: 'N',
    esnStatus: null,
    croStatus: null,
    holdCodeList: null,
    handlingDateTime: null,
    lsLocationType: null,
    vattinCode: null,
    cfsBy: null,
    cntrOpenTime: null,
    cntrCloseTime: null,
    gateInDatetime: null,
    gateOutDatetime: null,
    numberOfLabor: null,
    agentDeliveryDate: null,
    customsDeclarationNo: null,
    bookingNo1: null,
    iocBatchPaymentCntrSeq: null,
}

